export default "__VITE_ASSET__DAa7IJlJ__"